// import { FileType } from "../../types/indexTypeEnum";

interface ReturnValidateFile {
  isValidate: boolean;
  error?: string;
}

export const validateFile = (file: File): ReturnValidateFile => {
  // const type = file?.type;
  const fileSizeInMB = file?.size / (1024 * 1024);
  // if (!Object.values(FileType).includes(type as FileType)) {
  //   console.error("Не верный формат файла " + file.name + type);
  //   return {
  //     isValidate: false,
  //     error: `Не верный формат файла`,
  //   };
  // }
  if (fileSizeInMB > 20) {
    console.error("Размер файла превышает 20 МБ " + file.name);
    return {
      isValidate: false,
      error: `Размер файла превышает 20 МБ`,
    };
  }
  return {
    isValidate: true,
  };
};
